// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2LqWK","comment":"styles_comment__x8xMF"};